
import { Link } from 'react-router-dom';

export default function DealershipProducts() {
  const products = [
    {
      id: 1,
      name: 'Luxury Geo Domes',
      description: 'Premium geodesic dome structures with panoramic views and modern amenities.',
      features: ['360° Views', 'Weather Resistant', 'Quick Assembly', 'Customizable Interior'],
      price: 'Starting at $45,000',
      image: 'https://public.readdy.ai/ai/img_res/6f3c2827de9659a7efbc41d8bfaf4d62.jpg',
      category: 'Structures',
      learnMoreLink: '/experiences/mountain'
    },
    {
      id: 2,
      name: 'Designer Tiny Homes',
      description: 'Fully equipped tiny homes with luxury finishes and eco-friendly features.',
      features: ['Full Kitchen', 'Bathroom', 'Sleeping Loft', 'Energy Efficient'],
      price: 'Starting at $65,000',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20tiny%20home%20glamping%20accommodation%20with%20modern%20interior%20design%20and%20premium%20finishes%2C%20professional%20product%20photography%2C%20high-end%20mobile%20dwelling%2C%20sophisticated%20compact%20living%20space%2C%20designer%20tiny%20house%20showcase&width=400&height=300&seq=tiny-home-product&orientation=landscape',
      category: 'Structures',
      learnMoreLink: '/experiences/forest'
    },
    {
      id: 3,
      name: 'Safari Tents',
      description: 'Spacious canvas tents with solid floors and luxury furnishings.',
      features: ['Canvas Construction', 'Solid Flooring', 'Large Windows', 'Furnished Interior'],
      price: 'Starting at $25,000',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20safari%20tent%20glamping%20accommodation%20with%20canvas%20walls%20and%20elegant%20interior%20furnishing%2C%20professional%20product%20photography%2C%20premium%20outdoor%20hospitality%20tent%2C%20sophisticated%20camping%20structure%2C%20high-end%20safari%20tent%20showcase&width=400&height=300&seq=safari-tent-product&orientation=landscape',
      category: 'Structures',
      learnMoreLink: '/experiences/desert'
    },
    {
      id: 4,
      name: 'Solar Power Systems',
      description: 'Complete off-grid solar solutions for sustainable glamping operations.',
      features: ['Off-Grid Capable', 'Battery Storage', 'Monitoring System', 'Professional Installation'],
      price: 'Starting at $15,000',
      image: 'https://readdy.ai/api/search-image?query=Professional%20solar%20panel%20installation%20system%20for%20glamping%20retreat%20with%20battery%20storage%20and%20monitoring%20equipment%2C%20clean%20energy%20technology%2C%20sustainable%20power%20solution%2C%20off-grid%20solar%20system%20showcase%2C%20renewable%20energy%20setup&width=400&height=300&seq=solar-system-product&orientation=landscape',
      category: 'Systems',
      learnMoreLink: '/sustainability'
    },
    {
      id: 5,
      name: 'Glamping Pods',
      description: 'Modern pod-style accommodations with unique architectural design.',
      features: ['Modern Design', 'Insulated Structure', 'Large Windows', 'Compact Efficiency'],
      price: 'Starting at $35,000',
      image: 'https://readdy.ai/api/search-image?query=Modern%20glamping%20pod%20accommodation%20with%20sleek%20architectural%20design%20and%20large%20windows%2C%20professional%20product%20photography%2C%20contemporary%20outdoor%20hospitality%20structure%2C%20minimalist%20pod%20design%2C%20premium%20glamping%20unit%20showcase&width=400&height=300&seq=glamping-pod-product&orientation=landscape',
      category: 'Structures',
      learnMoreLink: '/experiences/lakeside'
    },
    {
      id: 6,
      name: 'Booking & POS Systems',
      description: 'Integrated technology solutions for reservations and payments.',
      features: ['Online Booking', 'Payment Processing', 'Inventory Management', 'Analytics Dashboard'],
      price: 'Starting at $5,000',
      image: 'https://readdy.ai/api/search-image?query=Modern%20point%20of%20sale%20system%20and%20booking%20software%20interface%20on%20tablet%20and%20computer%20screens%2C%20professional%20technology%20setup%2C%20hospitality%20management%20software%2C%20digital%20booking%20system%2C%20business%20technology%20showcase&width=400&height=300&seq=pos-system-product&orientation=landscape',
      category: 'Technology',
      learnMoreLink: '/consultation'
    }
  ];

  const categories = ['All', 'Structures', 'Systems', 'Technology'];

  return (
    <section id="products" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Premium Glamping Products</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our comprehensive product line includes everything needed to create successful glamping retreats. 
            All products come with full support, training, and marketing materials.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product) => (
            <div key={product.id} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="relative h-48">
                <img 
                  src={product.image} 
                  alt={product.name}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-emerald-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                    {product.category}
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{product.name}</h3>
                <p className="text-gray-600 mb-4">{product.description}</p>
                
                <div className="mb-4">
                  <h4 className="font-semibold text-gray-900 mb-2">Key Features:</h4>
                  <ul className="grid grid-cols-2 gap-1">
                    {product.features.map((feature, index) => (
                      <li key={index} className="text-sm text-gray-600 flex items-center">
                        <i className="ri-check-line text-emerald-600 mr-1"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
                
                <div className="flex items-center justify-between">
                  <div className="text-lg font-bold text-emerald-600">{product.price}</div>
                  <Link 
                    to={product.learnMoreLink}
                    className="bg-emerald-600 text-white px-4 py-2 rounded-lg hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Learn More
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/catalog"
            className="inline-block bg-emerald-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            Download Catalog
          </Link>
        </div>

      </div>
    </section>
  );
}
